var _desc, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgIconError(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "20px",
    height: "20px",
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "icon-alert") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _desc || (_desc = /*#__PURE__*/React.createElement("desc", null, "Created with Sketch.")), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Design",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Manager/Org-Registration---Design---Error",
    transform: "translate(-918.000000, -707.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "icon-alert",
    transform: "translate(918.000000, 707.000000)"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Oval",
    fill: "#E20F40",
    cx: 10,
    cy: 10,
    r: 10
  }), /*#__PURE__*/React.createElement("g", {
    id: "!",
    transform: "translate(9.000000, 4.000000)",
    fill: "#FFFFFF",
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0.000145031962,0.821295161 L0.000122858588,8.14194261 C-0.00496139709,8.4304448 0.184491497,8.700434 0.495939229,8.84675818 C0.80736982,8.9930743 1.19253919,8.9930743 1.50396978,8.84675818 C1.81541751,8.700434 2.00487041,8.4304448 1.99977062,8.1401744 L1.99978615,0.819182499 C2.0053785,0.603965603 1.90108529,0.393618076 1.71069861,0.238783693 C1.52035346,0.0839830893 1.26018483,-0.00212522929 0.989584742,0 C0.932605444,0.00297541458 0.931519457,0.00303057548 0.882606159,0.00835252369 C0.372977168,0.0567878966 -0.00853042992,0.408029057 0.000145031962,0.821295161 Z",
    id: "Path"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1,10 C0.450865721,10 0,10.4470616 0,10.9938013 C0,11.5416594 0.452026027,11.9935435 1,11.9935435 C1.54798472,11.9935435 2,11.5416677 2,10.9938013 C2,10.4470534 1.54914499,10 1,10 Z",
    id: "Path"
  })))))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconError);
export default __webpack_public_path__ + "static/media/icon-error.ff9918c992901e843dda6eb012729f89.svg";
export { ForwardRef as ReactComponent };